export enum BankTemplate {
  STANDARD = 'standard',
  ACB = 'acb',
  NBD = 'nbd',
  FIRST_NATIONAL = '1stNational',
  GRENADA = 'grenada',
  BOSVG = 'bosvg',
  BOSL = 'bosl',
  BON = 'bon',
  SKNA = 'skna',
  ECAB = 'ecab',
  VCB = 'vcb',
  HERITAGE_DOM = 'heritage-dom',
  HERITAGE_INT = 'heritage-int'
}